// @ts-ignore
export const all = (state) => state.all.map((one) => {
  const migrationAttributes: any = {};
  if (one.attributes.MEMBER_ID) {
    migrationAttributes.REFERREDBYREASON = one.attributes.MEMBER_ID;
  }
  if (one.attributes.REFERRAL) {
    migrationAttributes.REFERREDBY = one.attributes.REFERRAL;
  }


  return {
    ...migrationAttributes,
    ...one.attributes, ...one,
    activated: one.listIds.indexOf(8) !== -1,
    name: `${one.attributes.LASTNAME ?? ''} ${one.attributes.FIRSTNAME ?? ''}`,
    createdAt: new Date(one.createdAt).getTime(),
    modifiedAt: new Date(one.modifiedAt).getTime(),
    LAST_MODIFIED_AT_PARSED: new Date(one.attributes.LAST_MODIFIED_AT).getTime(),
  };
});

// @ts-ignore
export const generatedExternal = (state) => state.generatedExternal;
